import { memo } from 'react';
import { ReactComponent as ChevronIcon } from '@assets/icons/chevron-right.svg';
import { ReactComponent as Dots } from '@assets/icons/ellipsis-vertical.svg';
import config from 'config';
import Link from 'next/link';

import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList
} from '@chakra-ui/react';

const {
  colors: {
    palette: {
      dashboard: {
        dottedMenuButton: {
          background,
          borderBoxColor,
          cancelBorder,
          labelColor,
          iconColor
        }
      }
    }
  }
} = config;

interface DottedMenuButtonProps {
  detailsLink: string;
  isRescheduleAllow?: boolean;
  isRepeatAllow?: boolean;
  isCancelAllow?: boolean;
  onReschedule?: () => void;
  onRepeat?: () => void;
  onCancel?: () => void;
}

const DottedMenuButton = ({
  detailsLink,
  isRescheduleAllow = false,
  isRepeatAllow = false,
  isCancelAllow = false,
  onReschedule = () => {},
  onRepeat = () => {},
  onCancel = () => {}
}: DottedMenuButtonProps) => (
  <Menu
    placement='left-start'
    gutter={0}
    modifiers={[
      {
        name: 'offset',
        options: { offset: [0, 0] }
      },
      {
        name: 'flip',
        enabled: false
      },
      {
        name: 'preventOverflow',
        enabled: false
      }
    ]}
  >
    {!isRescheduleAllow && !isRepeatAllow && !isCancelAllow ? (
      <IconButton
        as={Link}
        href={detailsLink}
        bg='transparent'
        aria-label='open appointment details'
        icon={<ChevronIcon fill={iconColor} width={10} height={16} />}
      />
    ) : (
      <MenuButton
        as={IconButton}
        minW='auto'
        bg='transparent'
        borderRadius='2px'
        _active={{ bg: background, borderLeftRadius: 0 }}
        _hover={{ bg: background }}
        p={2}
        mr={1}
        aria-label='open actions menu'
      >
        <Dots fill={iconColor} width={20} height={20} />
      </MenuButton>
    )}

    <MenuList
      borderColor={borderBoxColor}
      borderWidth='1px'
      borderRadius={0}
      p={0}
      minW='180px'
      overflow='hidden'
    >
      <MenuItem
        as={Link}
        href={detailsLink}
        height={isCancelAllow ? '39px' : '39px'}
      >
        Details
      </MenuItem>

      {isRescheduleAllow && (
        <MenuItem color={labelColor} height='39px' onClick={onReschedule}>
          Reschedule
        </MenuItem>
      )}
      {isRepeatAllow && (
        <MenuItem color={labelColor} height='39px' onClick={onRepeat}>
          Repeat
        </MenuItem>
      )}
      {isCancelAllow && (
        <MenuItem
          color={labelColor}
          height='39px'
          borderTopWidth='0.5px'
          borderTopColor={cancelBorder}
          onClick={onCancel}
        >
          Cancel
        </MenuItem>
      )}
    </MenuList>
  </Menu>
);

export default memo(DottedMenuButton);
